import z from "zod";

export const LoginFormSchema = z.object({
	email: z.string().email().min(1),
	password: z
		.string()
		.min(7, { message: "Password must contain at least 7 characters" }),
	rememberMe: z.boolean(),
});
